export default class ActionResponseData {
  /**
   * @param props {Object}
   */
  constructor(props) {
    this.props = {
      url: props.url || null,
      redirect: props.redirect || null,
      fragments: props.fragments || {},
    };
  }

  process() {
    if (this.props.url) {
      window.history.replaceState('', '', this.props.url);
    }

    if (this.props.redirect) {
      window.location.replace(this.props.redirect);
    }

    this.renderFragments();
  }

  renderFragments() {
    Object.entries(this.props.fragments).forEach(([target, fragment]) => {
      const element = document.querySelector(target);

      if (!element) return;

      if (!(typeof fragment === 'string' || fragment instanceof String)) return;

      element.outerHTML = fragment;
      element.dispatchEvent(new Event('update'));
    });
  }
}
